// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/tenants/kiosk-permits/styles.scss
// module id = 1065
// module chunks = 62